module.exports = __webpack_public_path__ + "static/img/gp.5f1cc32.png";


//////////////////
// WEBPACK FOOTER
// ./src/assets/img/nav/cn/gp.png
// module id = aiAj
// module chunks = 1